import { AuthSDK } from 'postex-auth-sdk-stage';

const FALLBACK_PUBLIC_KEY = 'pk_live_jgPW5WrUIVEGI7YDA20Etb9j-q8d2Qb3';

export const authSdk = new AuthSDK({
  apiKey: import.meta.env.VITE_AUTH_SDK_PUBLIC_KEY || FALLBACK_PUBLIC_KEY,
  appId: 'postexglobal',
});
